import { render, staticRenderFns } from "./SubscriptionResourcesGrid.vue?vue&type=template&id=6d60d9b3&scoped=true&"
import script from "./SubscriptionResourcesGrid.vue?vue&type=script&lang=ts&"
export * from "./SubscriptionResourcesGrid.vue?vue&type=script&lang=ts&"
import style0 from "./SubscriptionResourcesGrid.vue?vue&type=style&index=0&id=6d60d9b3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d60d9b3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d60d9b3')) {
      api.createRecord('6d60d9b3', component.options)
    } else {
      api.reload('6d60d9b3', component.options)
    }
    module.hot.accept("./SubscriptionResourcesGrid.vue?vue&type=template&id=6d60d9b3&scoped=true&", function () {
      api.rerender('6d60d9b3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/SubscriptionResourcesGrid.vue"
export default component.exports